import { LoggedIn, LoggedOut } from './AuthClientBoundaryParts';

/**
 * AuthClientBoundary adds client boundary to logged in and logged out content.
 * Can be used inside server page components, when different content should be shown based on the user's session.
 *
 * `LoggedIn` and `LoggedOut` are exported as top-level named exports from a separate `'use client'`
 * module so each is a valid client reference. The namespace object is assembled here in a
 * server-safe module — assembling it inside the `'use client'` file would expose only the object as
 * a single client reference, and `AuthClientBoundary.LoggedIn` would resolve to `undefined` on the server.
 *
 * @property LoggedIn - The content to display when the user is logged in.
 * @property LoggedOut - The content to display when the user is logged out.
 */
const AuthClientBoundary = { LoggedIn, LoggedOut };

export { AuthClientBoundary };
